<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="输入商品名称" prefix-icon="el-icon-search"
                              clearable
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button>
                </div>
                <div>
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <!-- <el-button type="success" @click="importData" icon="el-icon-download">
                        {{importDataBtnText}}
                    </el-button>
                     -->
                    <el-button type="success" @click="exportTask" icon="el-icon-download">
                        导出列表
                    </el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加商品
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="4">
                            商品名称:
                            <el-input v-model="searchValue.name" placeholder="商品名称" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            型号:
                            <el-input v-model="searchValue.model" placeholder="型号" clearable size="mini"
                                       style="width: 150px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            配置:
                            <el-input v-model="searchValue.specifications" placeholder="配置" clearable size="mini"
                                       style="width: 150px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            颜色:
                            <el-select v-model="searchValue.color" clearable="" placeholder="颜色" size="mini"
                                       style="width: 80px;">
                                <el-option
                                        v-for="item in colorList"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="3" :offset="1" >
                            <el-button size="mini" @click="showAdvanceSearchView = !showAdvanceSearchView">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
                        </el-col>
                        <!-- <el-col :span="7">
                            聘用形式:
                            <el-radio-group v-model="searchValue.engageForm">
                                <el-radio label="劳动合同">劳动合同</el-radio>
                                <el-radio label="劳务合同">劳务合同</el-radio>
                            </el-radio-group>
                        </el-col> -->
                    </el-row>
                    
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%"
                    :row-key="row=>row.projectCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="name"
                        fixed
                        align="left"
                        label="商品名称"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="model"
                        width="300"
                        align="center"
                        label="型号">
                </el-table-column>
                <el-table-column
                        prop="specifications"
                        width="500"
                        align="center"
                        label="配置">
                </el-table-column>
                <el-table-column
                        prop="color"
                        width="80"
                        align="center"
                        label="颜色">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.color,'color')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="minPrice"
                        width="150"
                        align="center"
                        label="底价">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="260"
                        label="操作">
                    <template slot-scope="scope"> 
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="showChannelDetail(scope.row)" style="padding: 3px" size="mini">渠道</el-button>
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

         <!-- 渠道明细 --->
         <el-dialog
                :title="title"
                :visible.sync="detailDisplay"
                width="30%">
            <div>
                <el-table
                    :data="details"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="detailTable"
                    style="width: auto"
                    :row-key="row=>row.id"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                    <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                    </el-table-column> -->
                    <el-table-column
                           
                            align="center"
                            label="渠道名"
                            width="185">
                            <template slot-scope="scope">
                                <span > {{scope.row.name}}</span>
                                
                            </template>

                    </el-table-column>
                    <!-- <el-table-column
                            prop="plat"
                            align="center"
                            label="平台"
                            width="150">
                    </el-table-column> -->
                    <el-table-column
                            prop="price"
                            align="center"
                            label="价格"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="link"
                            align="center"
                            label="链接/微信号/qq"
                            width="120">
                    </el-table-column>
                    <el-table-column
                        
                        align="center"
                        width="110"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditDetailView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteDetail(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openAddDetail">添 加</el-button>
                <el-button @click="detailDisplay = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 渠道明细 --->
        <el-dialog
                :title="titleDetail"
                :visible.sync="showAddDetail"
                width="31%">
            <div>
                <el-form :model="detail" :rules="detailRules" ref="detailForm">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="" prop="name">
                                <label>渠&nbsp;&nbsp;道&nbsp;&nbsp;名:&nbsp;&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="detail.name"
                                          placeholder="请输入渠道名称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="" prop="price">
                                <label>价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格:&nbsp;&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="detail.price"
                                          placeholder="请输入价格"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="" prop="link">
                                <label>联系方式:&nbsp;&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="detail.link"
                                          placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDetail">确 认</el-button>
            </span>
        </el-dialog>

        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
                <el-col :span="24">
                    下单平台: 
                </el-col>
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->
           
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog>


        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="50%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="商品名称:" prop="projectName">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="emp.name"
                                          placeholder="请输入商品名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="型号:" prop="projectName">
                                
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="emp.model"
                                          placeholder="请输入型号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="" prop="projectName">
                                <label>配&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置:&nbsp;&nbsp;&nbsp;</label>
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="emp.specifications"
                                          placeholder="配置"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="颜色:" prop="totalPrice">
                              
                                <el-select v-model="emp.color" clearable="" placeholder="颜色" size="mini"
                                       style="width: 200px;">
                                <el-option
                                        v-for="item in colorList"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                            </el-form-item>
                        </el-col>
              
                    </el-row>
                   
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doAddGood">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "projectInfo",
        data() {
            return {
                // 岗位明细岗位参数
                detailDisplay:false,
                details:[],
                showAddDetail: false,
                detail:{},
                titleDetail: '',
                goodsCode: '', 
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null
                },
                colorList: [
                    {
                        dictValue: '0',
                        dictLabel: '其他'
                    }, 
                    {
                        dictValue: '1',
                        dictLabel: '红'
                    }, 
                    {
                        dictValue: '2',
                        dictLabel: '橙'
                    }, 
                    {
                        dictValue: '3',
                        dictLabel: '黄'
                    }, 
                    {
                        dictValue: '4',
                        dictLabel: '绿'
                    }, 
                    {
                        dictValue: '5',
                        dictLabel: '青'
                    }, 
                    {
                        dictValue: '6',
                        dictLabel: '蓝'
                    }, 
                    {
                        dictValue: '7',
                        dictLabel: '紫'
                    }
                ],
                title: '',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                emps: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
 
                emp: {
                    name: "",
                    model: "",
                    specifications: "",
                    color: "",
                    minPrice: ""
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    name: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    gender: [{required: true, message: '请输入性别', trigger: 'blur'}],
                    birthday: [{required: true, message: '请输入出生日期', trigger: 'blur'}],
                    idCard: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    wedlock: [{required: true, message: '请输入婚姻状况', trigger: 'blur'}],
                    nationId: [{required: true, message: '请输入您组', trigger: 'blur'}],
                    nativePlace: [{required: true, message: '请输入籍贯', trigger: 'blur'}],
                    politicId: [{required: true, message: '请输入政治面貌', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    phone: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
                    address: [{required: true, message: '请输入员工地址', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
            this.initPositions();
        },
        methods: {
            showEditDetailView(data) {
                // this.initPositions();
                this.titleDetail = '渠道编辑';
                this.detail = data;
                // this.inputDepName = data.department.name;
                this.showAddDetail = true;
            },
            openAddDetail(){
                this.titleDetail = '渠道添加';
                this.detail={}
                // this.title = '新建信息';
                // this.inputDepName = data.department.name;
                this.showAddDetail = true;
            },
            deleteDetail(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/train/channel/" + data.channelCode).then(resp => {
                        if (resp) {
                            this.initDetail();
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            addDetail(){
                this.detail.goodsCode = this.goodsCode;
                if (this.detail.id) {
                    this.$refs['detailForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/train/channel", this.detail).then(resp => {
                                if (resp) {
                                    this.showAddDetail = false;
                                    this.initDetail();
                                    
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['detailForm'].validate(valid => {
                        if (valid) {
                            this.postRequest('/yl/train/channel', this.detail).then(resp => {
                                if (resp) {
                                    this.showAddDetail = false;
                                    this.initDetail();
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            initDetail(){
                let param = {'goodCode':this.goodsCode}
                this.postRequest("/yl/train/channels", param).then(resp => {
                    if (resp) {
                        this.details = resp.data;
                    }
                })
            },
            showChannelDetail(row){
                this.goodsCode = row.goodsCode;
                let param = {'goodCode':this.goodsCode}
                this.postRequest("/yl/train/channels", param).then(resp => {
                    if (resp) {
                        this.details = resp.data;
                    }
                })
                this.detailDisplay=true; 
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('color' == z){
                    for (var i = 0; i < this.colorList.length; i++) {
                        if (this.colorList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.colorList[i].dictLabel;
                        }
                    }
                } 
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportData() {
                let a = this.$refs.projectTable.selection
                window.open('/employee/basic/export', '_parent');
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    name: "",
                    model: "",
                    specifications: "",
                    color: "",
                    minPrice: ""
                }
                this.inputDepName = '';
            },
            showEditEmpView(data) {
                // this.initPositions();
                this.title = '编辑商品信息';
                this.emp = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddGood() {
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/project/putProject", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/train/good", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initPositions() {
                this.getRequest('/employee/basic/positions').then(resp => {
                    if (resp) {
                        this.positions = resp;
                    }
                })
            },
            getMaxWordID() {
                this.getRequest("/employee/basic/maxWorkID").then(resp => {
                    if (resp) {
                        this.emp.workID = resp.obj;
                    }
                })
            },
            initData() {
                if (!window.sessionStorage.getItem("nations")) {
                    this.getRequest('/employee/basic/nations').then(resp => {
                        if (resp) {
                            this.nations = resp;
                            window.sessionStorage.setItem("nations", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.nations = JSON.parse(window.sessionStorage.getItem("nations"));
                }
                if (!window.sessionStorage.getItem("joblevels")) {
                    this.getRequest('/employee/basic/joblevels').then(resp => {
                        if (resp) {
                            this.joblevels = resp;
                            window.sessionStorage.setItem("joblevels", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.joblevels = JSON.parse(window.sessionStorage.getItem("joblevels"));
                }
                if (!window.sessionStorage.getItem("politicsstatus")) {
                    this.getRequest('/employee/basic/politicsstatus').then(resp => {
                        if (resp) {
                            this.politicsstatus = resp;
                            window.sessionStorage.setItem("politicsstatus", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.politicsstatus = JSON.parse(window.sessionStorage.getItem("politicsstatus"));
                }
                if (!window.sessionStorage.getItem("deps")) {
                    this.getRequest('/employee/basic/deps').then(resp => {
                        if (resp) {
                            this.allDeps = resp;
                            window.sessionStorage.setItem("deps", JSON.stringify(resp));
                        }
                    })
                } else {
                    this.allDeps = JSON.parse(window.sessionStorage.getItem("deps"));
                }
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加商品';
                this.getMaxWordID();
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword}
                if(type != 'advanced'){
                    this.searchValue = {}
                    this.searchValue['nameLike'] = this.keyword
                }else{
                    this.searchValue['nameLike'] = ''
                }
                this.searchValue['index']=this.page
                this.searchValue['pageSize']=this.size
                this.postRequest('/yl/train/goods', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
